// extracted by mini-css-extract-plugin
module.exports = {"line":"TotalLine_line__3Y8in","plan":"TotalLine_plan__KDfvw","cell":"TotalLine_cell__3fw1E","title":"TotalLine_title__1dkN4"};